import { render, staticRenderFns } from "./UsersFormComponent.vue?vue&type=template&id=664caebc&scoped=true"
import script from "./UsersFormComponent.vue?vue&type=script&lang=js"
export * from "./UsersFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664caebc",
  null
  
)

export default component.exports